import { Page } from '@/core/architecture'

import { ItemInformationTemplate } from './template'
import { useViewModel } from './viewModel'

export const ItemInformation: Page = () => {
  const { state, actions } = useViewModel()

  return <ItemInformationTemplate state={state} {...actions} />
}
